import apiClient from './api';

export const attendanceAPI = {
  // Get students for attendance marking
  getStudentsForAttendance: (params) => 
    apiClient.get('attendance/students', { params }),

  // Get attendance by date
  getAttendanceByDate: (params) => 
    apiClient.get('attendance/by-date', { params }),

  // Get monthly attendance data
  getMonthlyAttendance: (params) => 
    apiClient.get('attendance/monthly', { params }),

  // Mark bulk attendance
  markBulkAttendance: (data) => 
    apiClient.post('attendance/mark-bulk', data),

  // Get attendance report
  getAttendanceReport: (params) => 
    apiClient.get('attendance/report', { params }),

  // Download attendance report
  downloadAttendanceReport: async (params) => {
    const response = await apiClient.get('attendance/report/download', {
      params,
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `attendance_report_${new Date().toISOString().split('T')[0]}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return response;
  },

  // Get academic years
  getAcademics: () => 
    apiClient.get('academics'),

  // Get classes
  getClasses: () => 
    apiClient.get('classes'),

  // Get sections by class
  getSections: (classId) => 
    apiClient.get(`classes/${classId}/sections`),

  // Legacy CRUD operations
  getAttendance: (id) => 
    apiClient.get(`attendance/${id}`),

  createAttendance: (data) => 
    apiClient.post('attendance', data),

  updateAttendance: (id, data) => 
    apiClient.put(`attendance/${id}`, data),

  deleteAttendance: (id) => 
    apiClient.delete(`attendance/${id}`),

  listAttendance: (params) => 
    apiClient.get('attendance', { params }),
};
